import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useRatePlans} from '../hooks/useRatePlans.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useRatePlans();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};